import React, { useState } from 'react';
import {
  Box,
  Container,
  Tabs,
  Tab,
  Typography,
  Paper
} from '@mui/material';
import { Analytics, School } from '@mui/icons-material';

import AggregateDashboard from './AggregateDashboard';
import SchoolAnalysisView from './SchoolAnalysisView';

const ProjectionsAnalysis = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600, mb: 1 }}>
          Projections Analysis
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Validate projection accuracy through historical backtesting and statistical analysis
        </Typography>
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              minHeight: 64,
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500
            }
          }}
        >
          <Tab
            icon={<Analytics />}
            iconPosition="start"
            label="Aggregate Dashboard"
          />
          <Tab
            icon={<School />}
            iconPosition="start"
            label="School Analysis"
          />
        </Tabs>
      </Paper>

      <Box>
        {currentTab === 0 && <AggregateDashboard />}
        {currentTab === 1 && <SchoolAnalysisView />}
      </Box>
    </Container>
  );
};

export default ProjectionsAnalysis;

